import {
  LRUCache
} from './lru.js';

const LRUExpiry = function({
  capacity,
  scanDuration = 2 * 1000,
  maxTTL = 2 * 60 * 60 * 1000,
}) {
  this.lruCache = new LRUCache(capacity);
  this.scanDuration = scanDuration;

  if (this.scanDuration === 0) {
    this.scanDuration = 2 * 1000;
  }

  this.startTime = new Date().getTime();
  this.maxTTL = maxTTL;

  this.buckets = {};
};

LRUExpiry.prototype = {
  set: function(k, v, ttl = 5 * 60 * 1000) {
    const now = new Date().getTime();

    ttl = Math.min(ttl, this.maxTTL);

    if (ttl <= 0) {
      throw new Error(`ttl must be positive number, but get ${ttl}`);
    }

    const index = Math.floor((now + ttl - this.startTime) / this.scanDuration);
    this.buckets[index] = this.buckets[index] || [];
    this.buckets[index].push(k);

    return this.lruCache.set(k, v);
  },

  has: function(key) {
    return this.lruCache.has(key);
  },

  get: function(key) {
    return this.lruCache.get(key);
  },

  remove: function(key) {
    return this.lruCache.remove(key);
  },

  _scan: function() {
    const self = this;

    setTimeout(() => {
      self._scanExpire();

      self._scan();
    }, self.scanDuration);
  },

  _scanExpire: function() {
    const now = new Date().getTime();

    let index = Math.floor((now - self.startTime) / self.scanDuration) - 1;

    while (index >= 0) {
      if (!this.buckets[index]) {
        break;
      }

      this._expireBucket(index);

      index--;
    }
  },

  _expireBucket: function(index) {
    const list = this.buckets[index];

    for (let i = 0; i < list.length; i++) {
      this.remove(list[i]);
    }

    delete this.buckets[index];
  },
};

export {
  LRUExpiry
};
